var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"address-search-li",attrs:{"tabindex":"0"},on:{"click":_vm.selectAddress}},[_c('strong',[_vm._v(_vm._s(_vm.item.name))]),_c('br'),_c('span',[_vm._v(_vm._s(this.type))])])}
var staticRenderFns = []

export { render, staticRenderFns }